import { dashboardRoutePatterns } from "@/lib/dashboard-routes";

// `/[org]/sessions/[[...sessionPath]]` also serves `/[org]/sessions`.
const orgRoutesWithoutParams = new Set<string>(
  dashboardRoutePatterns
    .map((pattern) => pattern.replace(/\/\[\[\.\.\.[^\]]+\]\]$/, ""))
    .filter(
      (pattern) =>
        pattern.startsWith("/[org]") &&
        !pattern.slice("/[org]".length).includes("["),
    ),
);

/**
 * Resources in the current route don't exist in `orgName`, so land on the
 * nearest ancestor page: `/[org]/runs/[runId]/jobs/[jobId]` → `/acme/runs`.
 */
export function orgTargetPath(routePattern: string, orgName: string): string {
  const segments = routePattern.split("/");
  for (let end = segments.length; end > 2; end--) {
    const ancestor = segments.slice(0, end).join("/");
    if (orgRoutesWithoutParams.has(ancestor)) {
      return ancestor.replace("[org]", orgName);
    }
  }
  return `/${orgName}`;
}
